module.exports = "/images/pendant.svg?2cdcb2fa512b43aa6201b4f420233488";